module.exports = __webpack_public_path__ + "static/media/cel.54bea397.png";